import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import './themes/generated/theme.additional.css';
import React, {Component} from 'react';
import {HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import appInfo from './app-info';
import {navigation,getMenu} from './app-navigation';
import routes from './app-routes';
import './App.scss';
import './dx-styles.scss';
import {Footer, LoginForm,LoginForm2,LoginFormTrw} from './components';
import {
    SideNavOuterToolbar as SideNavBarLayout,
    SingleCard
} from './layouts';
import {sizes, subscribe, unsubscribe} from './utils/media-query';

import {connect, Provider} from "react-redux";
import {bindActionCreators} from "redux";
import {login, loginSuccess, logout} from './actions/AuthActions';
import { LoadPanel } from 'devextreme-react/load-panel';


const LoginContainer = ({logIn}) => {
    
    let url =  window.location.hostname;

    if (url.includes("tesvikmaster") ) { //||url.includes("185.96.171.211")
        return <LoginForm2 onLoginClick={logIn}/>
     } else if (url.includes("ari-ik")) { // || url.includes("176.236.189.152")
        return <LoginForm onLoginClick={logIn}/>
     }  else if (url.includes("trwturkiye")) {//else if (url.includes("trwturkiye")) { // || url.includes("176.236.189.152")
        return <LoginFormTrw onLoginClick={logIn}/>
     }  else if (window.location.hostname.includes("localhost")) {
        return <LoginForm2 onLoginClick={logIn}/>
     } else {
        window.location.href ="http://www.google.com";
        //window.location.reload();
        window.location.replace()
      
     }

    //  if(window.location.hostname.includes("ari-ik")){
    //     return <LoginForm onLoginClick={logIn}/>
    //  }else{
    //     return <LoginForm2 onLoginClick={logIn}/>
    //  }
    
};

const NotAuthPage = (props) => (
    <SingleCard>
        <Route render={() => <LoginContainer {...props} />}/>
    </SingleCard>
);

const AuthPage = (props) => (
    <SideNavBarLayout menuItems={getMenu()} title={appInfo.title} {...props}>
        <Switch>
            {routes.map(item => (
                <Route
                    exact
                    key={item.path}
                    path={item.path}
                    component={item.component}
                />
            ))}
            <Redirect to={'/'}/>
        </Switch>
       
      {/*   <Footer>
            Copyright © 2011-2019 Developer Express Inc.
            <br/>
            All trademarks or registered trademarks are property of their
            respective owners. 
        </Footer>
*/}
    </SideNavBarLayout>

);

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: true,
            screenSizeClass: this.getScreenSizeClass()
        };


        this.userMenuItems = [
            {
                text: 'Profile',
                icon: 'user',
                onClick: this.profile
            },
            {
                text: 'Parola değiştir',
                icon: 'key',
                onClick: this.changePassword
            },
            {
                text: 'Logout',
                icon: 'runner',
                onClick: this.logOut
            }
        ];

        this.checkLoggedIn();
    }


    checkLoggedIn() {
        let loggedIn= localStorage.getItem('loggedIn');
        let username = localStorage.getItem('username');
        let domainId = localStorage.getItem('domainId');
        let roles = JSON.parse(localStorage.getItem("roles"));  
        loggedIn = loggedIn === "true";
        this.props.actions.loginSuccess({loggedIn,username,roles});


    }
    componentDidMount() {
        subscribe(this.screenSizeChanged);
    }

    componentWillUnmount() {
        unsubscribe(this.screenSizeChanged);
    }

    render() {
        const {loggedIn} = this.props.AuthReducer.loginUserData;
        const {loadingData} = this.props.AppReducer;

        return (
            <div style={{height:'100%'}}>
                <div id="appmaindiv" style={{height:'100%'}}>
                    <div className={`app ${this.state.screenSizeClass}`}>
                        <Router>{loggedIn ? <AuthPage userMenuItems={this.userMenuItems} /> :
                            <NotAuthPage logIn={this.logIn} />}</Router>
                    </div>
                </div>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={{of: '#appmaindiv'}}
                    //onHiding={this.hideLoadPanel}
                    message={loadingData.text}
                    visible={loadingData.visible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    closeOnOutsideClick={true}
                />
            </div>
        );
    }

    getScreenSizeClass() {
        const screenSizes = sizes();
        return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
    }

    // eslint-disable-next-line no-undef
    screenSizeChanged = () => {
        this.setState({
            screenSizeClass: this.getScreenSizeClass()
        });
    }

    // eslint-disable-next-line no-undef
    logIn = (login,password) => {
        //this.setState({loggedIn: true});
      this.props.actions.login(login,password);
    };

    // eslint-disable-next-line no-undef
    logOut = () => {

        this.props.actions.logout();

    };

    // eslint-disable-next-line no-undef
    profile = () => {
        window.location.href = "/#/profile";
        //this.props.history.push("/profile");
    }

    // eslint-disable-next-line no-undef
    changePassword = () => {
        window.location.href = "/#/parolaDegistir";
    }
}



function mapDispatchToProps(dispatch) {
  return {
    actions: {
      login: bindActionCreators(login, dispatch),
      loginSuccess: bindActionCreators(loginSuccess, dispatch),
      logout: bindActionCreators(logout, dispatch),

    }
  };
}


function mapStateToProps(state) {
  return {
      AuthReducer: state.AuthReducer,
      AppReducer: state.AppReducer
  };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
